import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  CardMedia,
  CardActions,
  Box,
  Tooltip,
} from "@mui/material";
import { animated, useSpring } from "react-spring";
import memoji from "../assets/memoji.PNG";
import memoji2 from "../assets/memoji2.PNG";
import Header from "../components/header";
import Footer from "../components/footer";
import { useState, useEffect } from "react";

//techstack logos
import react from "../assets/techstack/react.png";
import node from "../assets/techstack/node.png";
// import figma from "../assets/techstack/figma.png";
import django from "../assets/techstack/django.png";
import bootstrap from "../assets/techstack/bootstrap.png";
import progres from "../assets/techstack/posgres.png";
import flutter from "../assets/techstack/flutterr.jpg";
import mysql from "../assets/techstack/mysql.png";
import php from "../assets/techstack/php.png";
import mongodb from "../assets/techstack/mongodb.jpg";

//social media icons
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import LinkIcon from '@mui/icons-material/Link';
import ArticleIcon from '@mui/icons-material/Article';

//projects images
import reviewmycafe from "../assets/project/reviewmycafe.jpg";
import powerhr from "../assets/project/powerhr.jpg";
import almari from "../assets/project/almari.jpg";
import belajarapi from "../assets/project/belajarapi.jpg";
import nasa from "../assets/project/nasa.jpg";

import Carousel from "../components/carousel";

const logos = [
  { src: bootstrap, alt: "Bootstrap" },
  { src: django, alt: "Django" },
  { src: progres, alt: "postgresSQL" },
];
const logos2 = [
  { src: react, alt: "React" },
  { src: flutter, alt: "Flutter" },
  { src: mysql, alt: "mySQL" },
];

const logos3 = [
  { src: node, alt: "Node" },
  { src: php, alt: "PHP" },
  { src: mongodb, alt: "MongoDB" },
];

function HomePage() {
  const [isFlipped, setIsFlipped] = useState(false);
  const props = useSpring({
    from: { opacity: 0, transform: "translateY(100px)" },
    to: { opacity: 1, transform: "translateY(0px)" },
    delay: 500,
  });

  const handleScroll = () => {
    const scrollPosition = window.scrollY;
    const threshold = 50; // set the threshold value to trigger the flip animation
    if (scrollPosition > threshold ) {
      setIsFlipped(true);
      
    } else {
      setIsFlipped(false);
    }
  };

  // Add a scroll listener to the window object to trigger the flip animation
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const BrandFont = {
    fontFamily: "Solitreo, cursive",
  };

  return (
    <div>
      <animated.div style={props}>
        <Header />
        <Grid container spacing={3}>
          <Grid item xs={12} md={3}></Grid>
          <Grid item xs={12} md={6}>
            <Card
              sx={{
                // maxHeight: 400,
                margin: "auto",
                marginTop: "10px",
                marginBottom: "10px",

                display: "flex",
                flexDirection: isSmallScreen ? "column" : "row",
                justifyContent: "center",
                alignItems: "center",
                boxShadow:
                  " rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;",
                borderRadius: "10px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  maxWidth: "50%",
                }}
              >
                <CardMedia
                  component="img"
                  width="100%"
                  image={isFlipped ? memoji2 : memoji}
                  alt={isFlipped ? "memoji2" : "memoji"}
                  sx={{
                    transform: isFlipped ? "rotateY(180deg)" : "rotateY(0deg)", 
                    transition: "transform 0.5s ease-in-out",
                  }}
                />
              </Box>
              <CardContent sx={{ width: isSmallScreen ? "100%" : "50%" }}>
                <Typography
                  variant="h5"
                  sx={{ ...BrandFont, textAlign: "center" }}
                  mt={6}
                >
                  Welcome to my portfolio!
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  mt={3}
                  mx={3}
                  sx={{ textAlign: "justify" }}
                >
                  "Passionate and self-taught, I am a software engineer and
                  developer constantly pushing my limits to grow both personally
                  and professionally. With an unwavering commitment to
                  excellence, I am always eager to take on new challenges and
                  expand my knowledge in the field of technology. Let's build
                  something great together."
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-evenly",
                    mt: 3,
                  }}
                >
                  <a href="https://github.com/aniqaqill">
                    <Tooltip title="GitHub" placement="bottom">
                      <GitHubIcon
                        sx={{
                          fontSize: 40,
                          color: "#000",
                          "&:hover": {
                            color: "text.secondary",
                          },
                          //new tab
                          target: "_blank",
                        }}
                      />
                    </Tooltip>
                  </a>
                  <a href="https://www.linkedin.com/in/aniq-aqil/">
                    <Tooltip title="LinkedIn" placement="bottom">
                      <LinkedInIcon
                        sx={{
                          fontSize: 40,
                          color: "#000",
                          "&:hover": {
                            color: "text.secondary",
                          },
                          //new tab
                          target: "_blank",
                        }}
                      />
                    </Tooltip>
                  </a>
                  <a href="mailto:aniqaqil06@gmail.com">
                    <Tooltip title="Email" placement="bottom">
                      <EmailIcon
                        sx={{
                          fontSize: 40,
                          color: "#000",
                          "&:hover": {
                            color: "text.secondary",
                          },
                          //new tab
                          target: "_blank",
                        }}
                      />
                    </Tooltip>
                  </a>
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={3}></Grid>
        </Grid>
        <Typography
          variant="h3"
          sx={{ ...BrandFont, textAlign: "center" }}
          mt={6}
        >
          My tech stack
        </Typography>
        <Grid container spacing={3} >
          <Grid item xs={12} md={3}></Grid>
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                height: "100px",
                width: "100%",
              }}
            >
              <Carousel logos={logos} />
              <Carousel logos={logos2} />
              <Carousel logos={logos3} />
            </Box>
          </Grid>
          <Grid item xs={12} md={3}></Grid>
        </Grid>
        <Typography
          variant="h3"
          sx={{ ...BrandFont, textAlign: "center" }}
          mt={6}
        >
          My Projects
        </Typography>
        <Typography variant="body1" sx={{ ...BrandFont, textAlign: "center" }}>
          Note that some of these projects github links are private.
        </Typography>
        <Grid container spacing={3} >
          <Grid item xs={12} md={4}>
            <Card
              sx={{
                // maxHeight: 400,
                margin: "10px",
                marginTop: "10px",
                marginBottom: "10px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                boxShadow:
                  " rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;",
                borderRadius: "10px",
              }}
            >
              <CardMedia
                component="img"
                width="100%"
                image={reviewmycafe}
                alt="reviewmycafe"
              />
              <CardContent sx={{ width: isSmallScreen ? "90%" : "60%" }}>
                <Typography
                  variant="h5"
                  sx={{ ...BrandFont, textAlign: "center" }}
                >
                  ReviewMyCafe 
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ textAlign: "justify" }}
                >
                  Personal Projects using Django. A web application for a café shop, which allows users to submit their café shops to be added to the list. Users can also leave reviews and ratings for the café shops.
                </Typography>
              </CardContent>
              <CardActions>
              <a target="blank" href="https://github.com/aniqaqill/coffeeshop">
                    <GitHubIcon  sx={{ fontSize: 30, color: "#000", "&:hover": { color: "text.secondary" }, }} /></a>
              </CardActions>
            </Card>
          </Grid>
          <Grid item xs={12} md={4}>
          <Card
              sx={{
                // maxHeight: 400,
                margin: "10px",
                marginTop: "10px",
                marginBottom: "10px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                boxShadow:
                  " rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;",
                borderRadius: "10px",
              }}
            >
              <CardMedia
                component="img"
                width="100%"
                image={powerhr}
                alt="powerhr"
              />
              <CardContent sx={{ width: isSmallScreen ? "90%" : "60%" }}>
                <Typography
                  variant="h5"
                  sx={{ ...BrandFont, textAlign: "center" }}
             
                >
                  PowerHR
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ textAlign: "justify" }}
                >
                  A group project using MERN stack. A web application for analyzing a company turnover rate through data visualization and employee feedback. Ease HR management process.
                </Typography>
              </CardContent>
              <CardActions>
              <a mx={2} target="blank" href="https://github.com/App-Dev-ZAFC-v2/Power-HR-System">
                    <GitHubIcon  sx={{ fontSize: 30, color: "#000", "&:hover": { color: "text.secondary" }, }} /></a>
                    <a mx={2} target="blank" href="https://kind-smoke-0edc73600.2.azurestaticapps.net/">
                      <LinkIcon  sx={{ fontSize: 30, color: "#000", "&:hover": { color: "text.secondary" }, }} /></a>
              </CardActions>
            </Card>
          </Grid>
          <Grid item xs={12} md={4}>
          <Card
              sx={{               
                margin: "10px",
                marginBottom: "10px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                boxShadow:
                  " rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;",
                borderRadius: "10px",
              }}
            >
              <CardMedia
                component="img"
                width="100%"
                image={almari}
              />
              <CardContent sx={{ width: isSmallScreen ? "90%" : "60%"  }}>
                <Typography
                  variant="h5"
                  sx={{ ...BrandFont, textAlign: "center" }}
          
                >
                  Almari.com
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ textAlign: "justify" }}
                >
                  A group project using Bootstrap and PHP and deployed using Runcloud. Its a web application for a clothing sustainability. Build for Runcloud Young Technovation competition. Awarded 2nd Runner Up.
                </Typography>
              </CardContent>
              <CardActions>
              <a mx={2} target="blank" href="https://github.com/aniqaqill/almari">
                    <GitHubIcon  sx={{ fontSize: 30, color: "#000", "&:hover": { color: "text.secondary" }, }} /></a>
                    <Tooltip title="2nd Runner Up Post in Facebook" placement="top" >
                    <a mx={2} target="blank" href="https://news.utm.my/2022/12/faculty-of-computings-students-stand-out-in-various-competitions/">
                      <ArticleIcon  sx={{ fontSize: 30, color: "#000", "&:hover": { color: "text.secondary" }, }} /></a>
                    </Tooltip>
              </CardActions>
            </Card>
            </Grid>
        </Grid>
        <Grid container spacing={3} >
          <Grid item xs={12} md={2}></Grid>
          <Grid item xs={12} md={4}>
            <Card
              sx={{
                // maxHeight: 400,
                margin: "10px",
                marginTop: "10px",
                marginBottom: "10px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                boxShadow:
                  " rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;",
                borderRadius: "10px",
              }}
            >
              <CardMedia
                component="img"
                width="100%"
                image={belajarapi}
                alt="crud app"

              />
              <CardContent sx={{ width: isSmallScreen ? "90%" : "60%" }}>
                <Typography
                  variant="h5"
                  sx={{ ...BrandFont, textAlign: "center" }}
                >
                  React CRUD 
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ textAlign: "justify" }}
                >
                  A simple CRUD application using React and Firebase.Learn how to create, read, update and delete data from Firebase.First encounter with React and API.
                </Typography>
              </CardContent>
              <CardActions>
              <a mx={2} target="blank" href="https://github.com/aniqaqill/belajar-api">
                    <GitHubIcon  sx={{ fontSize: 30, color: "#000", "&:hover": { color: "text.secondary" }, }} /></a>
                    <a mx={2} target="blank" href="https://aniqaqill.github.io/belajar-api/">
                      <LinkIcon sx={{ fontSize: 30, color: "#000", "&:hover": { color: "text.secondary" }, }} /></a>
              </CardActions>
            </Card>
          </Grid>
          <Grid item xs={12} md={4}>
          <Card
              sx={{
                // maxHeight: 400,
                margin: "10px",
                marginTop: "10px",
                marginBottom: "10px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                boxShadow:
                  " rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;",
                borderRadius: "10px",
              }}
            >
              <CardMedia
                component="img"
                width="100%"
                image={nasa}
                alt="nasa"
              />
              <CardContent sx={{ width: isSmallScreen ? "80%" : "60%" }}>
                <Typography
                  variant="h5"
                  sx={{ ...BrandFont, textAlign: "center" }}
             
                >
                  Nasa Application
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ textAlign: "justify" }}
                >
                  Personal Project using React and NASA API. Learn how to use API and React. Also learn how to use Material UI in building a web application.
                </Typography>
              </CardContent>
              <CardActions>
              <a mx={2} target="blank" href="https://github.com/aniqaqill/nasa">
                    <GitHubIcon  sx={{ fontSize: 30, color: "#000", "&:hover": { color: "text.secondary" }, }} /></a>
                    <a mx={2} target="blank" href="https://aniqaqill.github.io/nasa/">
                      <LinkIcon  sx={{ fontSize: 30, color: "#000", "&:hover": { color: "text.secondary" }, }} /></a>
              </CardActions>
            </Card>
          </Grid>
        </Grid>
        </animated.div>
      <Footer />
    </div>
  );
}

export default HomePage;
